import { useEffect, useState } from 'react';
import { useMultipleProfiles } from '@/store/useMultipleProfiles';
import useGetBusinessFacilityInformation from '@/api/hooks/useGetBusinessFacilityInformation';
import { BUSINESS_DETAILS_SECTION_ID } from '@/pages/Facilities/Sections/Details/types';
import { SOFTWARE_LICENSE_PAGE_ID } from '@/pages/Facilities/Sections/Details/SoftwareLicense/data';

export const useCheckTier1WithoutLicense = () => {
  const userProfile = useMultipleProfiles((state) => state.userProfile);
  const [noEligibleLicense, setNoEligibleLicense] = useState(false);

  const facilityId = userProfile?.SystemUser?.facilities?.[0]?.id;
  const businessId = userProfile?.businesses?.[0]?.id;

  const { data: softwareLicenseData, refetch: reCheckTier1WithoutLicense } =
    useGetBusinessFacilityInformation(
      businessId ?? '',
      facilityId ?? '',
      BUSINESS_DETAILS_SECTION_ID,
      SOFTWARE_LICENSE_PAGE_ID,
      { enabled: !!businessId && !!facilityId },
    );

  useEffect(() => {
    if (userProfile?.isTierOne) {
      const softwareLicenseValue = softwareLicenseData?.page?.items?.find(
        (v) => v.id === 'license-number',
      )?.answer;

      if (softwareLicenseData && !softwareLicenseValue) {
        setNoEligibleLicense(true);
      } else {
        setNoEligibleLicense(false);
      }
    }
  }, [softwareLicenseData, userProfile]);

  return { noEligibleLicense, reCheckTier1WithoutLicense };
};
